import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
//import { MyUrl } from "../../../App";
import moment from "moment";
import { Checkbox } from "@mui/material";
//mport { makeStyles } from "@material-ui/core/styles";
//import { withStyles } from "@mui/styles";
//import CheckIcon from "@material-ui/icons/Check";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
import { Divider } from "antd";
//import IncomeFirstTable from "./IncomeFirstTable";
//import IncomeGraph from "./IncomeGraph";
//import IncomeSecondTable from "./IncomeSecondTable";
import jwt_decode from "jwt-decode";
import Lottie from "lottie-react";
import UnboxtheBlackbox from "../../UnboxtheBlackbox.json";
// import loading33refresh from "../../../loading33refresh.json";
// import loadingrefresh from "../../../loadingrefresh.json";
// import refreshicon from "../../../refreshicon.json";
import reloadpage from "../../reloadpage.json";
import { Switch } from "antd";
import DashboardFirstTable from "../DashboardComponents/DashboardFirstTable";
import MainPageLeftDrawer from "./MainPageLeftDrawer";
var SendDataToFirstTable = [];
var ObjSendDataToFirstTable = {};

var jwtToken = "";

var SendDataToFirstTable1 = [];
var ObjSendDataToFirstTable1 = {};

var SendDataToIncomeGraph = [];
var ObjSendDataToIncomeGraph = {};
var SendDataToIncomeGraph1 = [];
var SendDataToSecondTable = [];
var SendDataToSecondTable1 = [];

var TotalOfDailyChange = 0;
var currentValue1 = 0;
var prevValue1 = 0;
var AfterCalc1 = currentValue1 - prevValue1;
var PickedDate = 0;

// const CircleCheckbox = ({ classes, ...props }) => (
//   <Checkbox
//     {...props}
//     classes={{
//       root: classes.root,
//       checked: classes.checked,
//     }}
//     icon={<span className={classes.circle} />}
//     checkedIcon={
//       <span className={classes.checkedIcon}>
//         sss
//         {/* <CheckIcon style={{ fontSize: 16, color: "black" }} /> */}
//       </span>
//     }
//   />
// );
export default function Dashboard() {
  //when pick today
  const Today = moment().add("days").format("YYYY-MM-DD");
  //when pick yesterday
  const Yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
  //when pick 7 days
  const SevenDays = moment().subtract(7, "day").format("YYYY-MM-DD");

  //For CheckBox
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  //End for CheckBox

  //Select Days
  const [days, setDays] = React.useState(0);
  const handleChangeDays = (event) => {
    setDays(event.target.value);
    // PickDatesToGetData(event.target.value);
  };
  //End select Days

  const [OpenRange, SetOpenRange] = useState(false);
  var startDate = Today;
  var endDate = Today;

  async function PickDatesToGetData(event) {
    setDays(event);
    if (event === 0) {
      SetOpenRange(false);
      startDate = Today;
      endDate = Today;
      console.log("today1");

      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
      // GetDailyIncomeFunc1(Today, Today);
      // GetMonthlyIncomeFunc(Today, Today);
    } else if (event === 1) {
      SetOpenRange(false);
      startDate = Yesterday;
      endDate = Yesterday;
      console.log("Yesterday1");
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    } else if (event === 2) {
      SetOpenRange(false);
      startDate = SevenDays;
      endDate = Yesterday;
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    } else if (event === 3) {
      SetOpenRange(false);
      startDate = FirstDayInMonth;
      endDate = Yesterday;
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    } else if (event === 4) {
      if (value.$D === undefined) {
        startDate = Today;
      } else {
        startDate = `${value.$y}-${value.$M + 1}-${value.$D}`;
      }
      if (value1.$D === undefined) {
        endDate = Today;
      } else {
        endDate = `${value1.$y}-${value1.$M + 1}-${value1.$D}`;
      }
      SetOpenRange(true);
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    }
  }
  const [height, width] = useWindowSize();

  const [Loading, setLoading] = useState(false);
  const [chooceCompanies, setChooceCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState("");
  const [isLoading1, setIsLoading1] = useState(true);
  const [data1, setData1] = useState("");
  const [isLoading2, setIsLoading2] = useState(true);
  const [data2, setData2] = useState("");

  var LastDayInMonth = moment(LastDayInMonth)
    .endOf("month")
    .format("YYYY-MM-DD");

  var FirstDayInMonth = moment(FirstDayInMonth)
    .startOf("month")
    .format("YYYY-MM-DD");

  const currentDate = moment();
  const daysInCurrentMonth = currentDate.daysInMonth();
  const [selectedObject, setSelectedObject] = useState(true);
  const [count, setCount] = useState(0);

  const handleCheckboxChange = (event, productName) => {
    if (event.target.checked) {
      setChooceCompanies([...chooceCompanies, productName]); // add to array
    } else {
      setChooceCompanies(
        chooceCompanies.filter((name) => name !== productName)
      );
      console.log(chooceCompanies);
      console.log(SendDataToSecondTable);
      console.log("SendDataToIncomeGraph1");
      console.log(SendDataToSecondTable1);
    }
  };
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const urlParams1 = window.location.search;
  const IdsToGetData = []; //chooceCompanies.map((id) => "," + String(id)).join("");

  const getCustomersData1 = async () => {
    setIsLoading(true);
    try {
      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetSeats?clearCacheForUpload=false`
        )
        .then((res) => {
          const data = res.data;
          setData(data);
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            console.log(data[i].id);
            IdsToGetData.push(data[i].id);
            console.log(IdsToGetData);

            setChooceCompanies((prevCompanies) => [
              ...prevCompanies,
              data[i].id,
            ]);
          }
          getCustomersData(startDate, endDate);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading(false);
        });
    } catch (err) {}
  };
  {
    urlParams1 === ""
      ? console.log("yes")
      : localStorage.setItem("Token", JSON.stringify(urlParams1));
  }

  const items = localStorage.getItem("Token");
  const trimmedMyaa = items.substring(1, items.length - 1);
  const aa = trimmedMyaa.replace("?jwt=", "");
  const [isClicked, setIsClicked] = useState(false);

  const [isClicked1, setIsClicked1] = useState(false);

  const onChange = (checked) => {
    setIsClicked1(checked);
    console.log(`switch to ${checked}`);
  };
  const getCustomersData = (startDate, endDate) => {
    try {
      setLoading(false);
      // console.log(endDate);
      // console.log(chooceCompanies.toString());
      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetDashboardReport?dateFrom=${startDate}&dateTo=${endDate}&existingOnly=${isClicked1}`,

          // `https://dsp-api.o2rintelligence.com/api/dashboard/GetDashboardReportSeats?dateFrom=${startDate}&dateTo=${endDate}&seatIds=${IdsToGetData.toString()}`,
          {
            headers: {
              // Authorization: `Bearer ${window.location.search.replace(
              //   "?jwt=",
              //   ""
              // )}`,
              Authorization: `Bearer ${aa}`,
            },
            //cancelToken: source.token,
          }
        )
        .then((res) => {
          const data = res.data;
          console.log(data);
          SendDataToFirstTable = [];
          for (let i = 0; i < data.length; i++) {
            ObjSendDataToFirstTable = {
              seatName: data[i].seatName,
              sourceId: data[i].source.id,
              sourceName: data[i].source.name,
              environmentName: data[i].environment.name,
              targeting: data[i].isRon ? "RON" : "WL",
              geo: data[i].geo,
              ad_requests: data[i].ad_requests,
              ad_opportunities: data[i].ad_opportunities,
              impressions_good: data[i].impressions_good,
              fill_rate_ad_requests: data[i].fill_rate_ad_requests,
              Action: data[i].seatName,
            };
            SendDataToFirstTable.push(ObjSendDataToFirstTable);
          }
        })

        .catch((error) => {})
        .finally(() => {
          setLoading(true);
        });
    } catch (err) {}
  };

  useEffect(() => {
    setChooceCompanies([]);
    getCustomersData1();
    //  PickDatesToGetData(0);
    //    getCustomersData1();
    const items = localStorage.getItem("Token");
    console.log(items.replace("?jwt=", ""));
    //await getCustomersData(startDate, endDate, chooceCompanies.toString());
  }, []);
  var [value, setValue] = React.useState(startDate);
  var [value1, setValue1] = React.useState(endDate);
  const handleChange3 = (newValue) => {
    setValue(newValue);
    startDate = `${newValue.$y}-${newValue.$M + 1}-${newValue.$D}`;
  };

  const handleChange4 = (newValue1) => {
    setValue1(newValue1);
    endDate = `${newValue1.$y}-${newValue1.$M + 1}-${newValue1.$D}`;
  };

  return (
    <div style={{}}>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            overflowX: width > 766 ? "auto" : "scroll",
          }}
        >
          {" "}
          <Skeleton
            animation="wave"
            width={750}
            height={80}
            borderRadius={100}
          />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                overflowX: width > 766 ? "" : "scroll",
                alignItems: "center",
              }}
            >
              <button
                style={{
                  border: "none",
                  background: "white",
                  cursor: "pointer",
                  minWidth: 60,
                }}
                onClick={() => {
                  onChange();
                  setIsLoading2(true);
                  setIsLoading1(true);
                  PickDatesToGetData(PickedDate);
                  setIsClicked(true);
                  setTimeout(() => setIsClicked(false), 1000);
                }}
              >
                <Lottie
                  loop={isClicked ? true : false}
                  autoplay={isClicked ? true : false}
                  animationData={reloadpage}
                  rendererSettings={{
                    preserveAspectRatio: "xMidYMid slice",
                    display: "flex",
                    background: "white",
                    borderRadius: 100,
                    justifyContent: "center",
                    alignItems: "center",
                    margin: 3,
                    paddingRight: 5,
                    height: 40,
                    width: 60,
                    minWidth: 60,
                  }}
                  isPaused={isClicked}
                />
              </button>
              <div
                style={{ flex: 1, display: "flex", flexDirection: "column" }}
              >
                <a>Show only existing in Sources</a>
                <div>
                  <Switch onChange={onChange} />
                  {/*defaultChecked*/}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: "1%",
              }}
            >
              <Box sx={{ minWidth: 150 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">days</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={days}
                    label="days"
                    onChange={handleChangeDays}
                  >
                    <MenuItem
                      sx={{ width: 200 }}
                      value={0}
                      onClick={() => {
                        PickedDate = 0;
                        PickDatesToGetData(0);
                      }}
                    >
                      Today
                    </MenuItem>
                    <MenuItem
                      value={1}
                      onClick={() => {
                        PickedDate = 1;
                        PickDatesToGetData(1);
                      }}
                    >
                      Yesterday
                    </MenuItem>
                    <MenuItem
                      value={2}
                      onClick={() => {
                        PickedDate = 2;
                        PickDatesToGetData(2);
                      }}
                    >
                      Last 7 Days
                    </MenuItem>
                    <MenuItem
                      value={3}
                      onClick={() => {
                        PickedDate = 3;
                        PickDatesToGetData(3);
                      }}
                    >
                      This Months
                    </MenuItem>
                    <div style={{ height: 1 }}>
                      <Divider />
                    </div>
                    {/* <div style={{ display: "flex", flexDirection: "column" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="From Date"
                          inputFormat="DD-MM-YYYY"
                          value={value}
                          onChange={handleChange3}
                          renderInput={(params) => <TextField {...params} />}
                        />
                        &nbsp;&nbsp;
                        <DesktopDatePicker
                          label="To Date"
                          inputFormat="DD-MM-YYYY"
                          value={value1}
                          onChange={handleChange4}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </div>

                    <br></br>

                    <MenuItem
                      value={4}
                      onClick={() => {
                        PickedDate = 4;
                        SetOpenRange(true);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "black",
                            textTransform: "none",
                            fontSize: "100%",
                            borderRadius: "12px",
                          }}
                          onClick={() => {
                            if (value === "" || value1 === "") {
                            } else {
                              SetOpenRange(false);
                              PickDatesToGetData(4);
                            }
                          }}
                        >
                          Custom Range
                        </Button>
                      </div>
                    </MenuItem> */}
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>
        </>
      )}

      {Loading ? (
        <DashboardFirstTable
          SendDataToFirstTable={SendDataToFirstTable}
          startDate={startDate}
          endDate={endDate}
        />
      ) : (
        <div
          style={{
            flex: 1,
            height: 500,
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Skeleton
            animation="wave"
            width={window.innerWidth}
            height={"100%"}
            borderRadius={100}
          />
        </div>
      )}
    </div>
  );
}
